import * as React from 'react';

import { FormField } from 'components/form';
import Input from 'components/inputs/input/Input';
import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';
import { sanitizeValue } from 'modules/insights/sov/utils/sov';

import './sov-queries-input-custom.scss';

import type { TextEntry, TextEntryKeyboardEvent } from 'types';

import type { SyntheticEvent } from 'react';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('modules/insights/sov/components/queries/modals/sov-queries-modal.i18n.json'));

type Props = {
  value: string,
  onAdd: () => void,
  onChange: (a: string) => void,
  onKeyPress: (a: TextEntryKeyboardEvent) => void
};

const COLLABARY_MSG_KEY = 'collabary_common';
const MODAL_MSG_KEY = 'sov_queries_modal';

class SOVQueriesInputCustom extends React.PureComponent<Props> {
  handleChange = (event: SyntheticEvent<TextEntry>): void => {
    const { onChange } = this.props;
    const target = event.currentTarget;
    const value = target.value || '';

    onChange(sanitizeValue(value));
  };

  renderButton(): React.ReactNode {
    const { value, onAdd } = this.props;

    return (
      <div className="sov-queries-input-custom__button">
        <ActionButton
          type="button"
          color="tertiary"
          width="minimum"
          disabled={value.length === 0}
          onClick={onAdd}
        >
          {__t(`${COLLABARY_MSG_KEY}.action_button.add`)}
        </ActionButton>
      </div>
    );
  }

  renderInput(): React.ReactNode {
    const { value, onKeyPress } = this.props;

    return (
      <div className="sov-queries-input-custom__input">
        <Input
          width="responsive"
          value={value}
          placeholder={__t(`${MODAL_MSG_KEY}.placeholders.add_custom_term`)}
          onChange={this.handleChange}
          onKeyPress={onKeyPress}
        />
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="sov-queries-input-custom">
        <FormField
          direction="column"
          label={__t(`${MODAL_MSG_KEY}.messages.define_results`)}
          tooltipMessage={__t(`${MODAL_MSG_KEY}.tooltips.define_results`)}
          tooltipWidth="long"
          labelType="highlighted"
          fontSize="small"
          showValidationIcon={false}
          showRequiredMark
        >
          <div className="sov-queries-input-custom__contents">
            {this.renderInput()}
            {this.renderButton()}
          </div>
        </FormField>
      </div>
    );
  }
}

export default SOVQueriesInputCustom;
